import { render, staticRenderFns } from "./scheduleClassesMonth.vue?vue&type=template&id=52c18863&scoped=true"
import script from "./scheduleClassesMonth.vue?vue&type=script&lang=js"
export * from "./scheduleClassesMonth.vue?vue&type=script&lang=js"
import style0 from "./scheduleClassesMonth.vue?vue&type=style&index=0&id=52c18863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c18863",
  null
  
)

export default component.exports